// extracted by mini-css-extract-plugin
export default {"input":"Input_input__rxmnz","label":"Input_label__6-Flt","inputResponsive":"Input_inputResponsive__-25Dn"};